import React from "react";
import { connect } from "react-redux";
import axios from "axios";

// @material-ui/core components
import { withStyles } from "tss-react/mui";
import { FormControl, MenuItem, Select } from "@mui/material";

import Pills from "../../components/Badge/Badge";

// material-ui icons
import { ViewCarousel, Visibility } from "@mui/icons-material";
import VestigingFilter, { getVestigingFilterState } from "../../components/VestigingFilter/VestigingFilter";
import { convertArrayToSelectOptions } from "../../templateHelpers";

import { errorLevels } from "../../variables/app";

// core components
import GridContainer from "../../components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import JamezzTable from "../../components/JamezzTable/JamezzTable";

import tafelStyle from "../../assets/jss/material-dashboard-pro-react/views/tafelStyle";
import MainNavbar from "../../components/Navbars/MainNavbar";
import Detail from "./Modals/Detail";
import TranslationWrapper, { getTranslation } from "../../components/TranslationWrapper/TranslationWrapper";
import { format } from "date-fns";

class Index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      apiFilter: [],

      detailModel: false,
      selectedId: null,
    };
  }

  /**
   * Component life cycle functies
   */
  componentDidMount() {
    this.loadFilterData();
  }

  toggleModal(modal) {
    let newState = { ...this.state };
    newState[modal] = !this.state[modal];
    this.setState(newState);
  }

  handleDetailAction = (row) => {
    this.setState({
      selectedId: row[0],
      detailModel: true,
    });
  };

  handleCustomDatum = (item) => {
    return format(new Date(item.created_at), "dd-MM-yyyy HH:mm:ss");
  };

  handleCustomLevel = (level) => {
    let color = "info";
    let text = "info";

    switch (level) {
      case 0:
        color = "warning";
        text = "EMERGENCY";
        break;
      case 1:
        color = "warning";
        text = "ALERT";
        break;
      case 2:
        color = "danger";
        text = "CRITICAL";
        break;
      case 3:
        color = "danger";
        text = "ERROR";
        break;
      case 4:
        color = "warning";
        text = "WARNING";
        break;
      case 5:
        color = "info";
        text = "NOTICE";
        break;
      case 6:
        color = "info";
        text = "INFO";
        break;
      case 7:
        color = "info";
        text = "DEBUG";
        break;
    }

    return <Pills color={color}>{text}</Pills>;
  };

  loadFilterData = () => {
    /**
     * Inladen van filter data op apis
     */
    axios.get("core/callbacklog/apifilterdata").then((response) => {
      this.setState({ apiFilter: response.data.data });
    });
  };

  render() {
    const { classes } = this.props;

    const errorLevelOpties = convertArrayToSelectOptions(errorLevels, classes);
    const apiOpties = convertArrayToSelectOptions(this.state.apiFilter, classes);

    return (
      <div>
        <MainNavbar paginaTitel={<TranslationWrapper tDefault={"Callbacklog"} tKey={"callbacklog.pagetitle"} />} />

        <GridContainer>
          <VestigingFilter />
          <GridItem sm={2} xs={12}>
            <FormControl className={classes.selectFormControl} fullWidth>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                inputProps={{
                  name: "simpleSelect",
                  id: "simple-select",
                  style: { paddingTop: "32px" },
                }}
                onChange={(e) => {
                  switch (e.target.value) {
                    case "ALL":
                      this.props.setFilter("callbacklog:api", null);
                      break;
                    default:
                      this.props.setFilter("callbacklog:api", {
                        field: "api",
                        operator: "=",
                        value: e.target.value,
                      });
                      break;
                  }
                }}
                value={this.props.filters["callbacklog:api"]?.value ?? "ALL"}
              >
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                  key={"ALL"}
                  value={"ALL"}
                >
                  <TranslationWrapper tDefault={"Selecteer api"} tKey={"callbacklog.filter.apiFilterAll"} />
                </MenuItem>
                {apiOpties}
              </Select>
            </FormControl>
          </GridItem>
          <GridItem sm={2} xs={12}>
            <FormControl className={classes.selectFormControl} fullWidth>
              <Select
                MenuProps={{
                  className: classes.selectMenu,
                }}
                classes={{
                  select: classes.select,
                }}
                inputProps={{
                  name: "simpleSelect",
                  id: "simple-select",
                  style: { paddingTop: "32px" },
                }}
                onChange={(e) => {
                  switch (e.target.value) {
                    case "ALL":
                      this.props.setFilter("callbacklog:level", null);
                      break;
                    default:
                      this.props.setFilter("callbacklog:level", {
                        field: "level",
                        operator: "=",
                        value: e.target.value,
                      });
                      break;
                  }
                }}
                value={this.props.filters["callbacklog:level"]?.value ?? "ALL"}
              >
                <MenuItem
                  classes={{
                    root: classes.selectMenuItem,
                    selected: classes.selectMenuItemSelected,
                  }}
                  key={"ALL"}
                  value={"ALL"}
                >
                  <TranslationWrapper tDefault={"Selecteer level"} tKey={"callbacklog.filter.errorLevelAll"} />
                </MenuItem>
                {errorLevelOpties}
              </Select>
            </FormControl>
          </GridItem>
        </GridContainer>
        <GridContainer>
          <GridItem xs={12}>
            <JamezzTable
              actions={[
                {
                  icon: Visibility,
                  tooltip: <TranslationWrapper tDefault={"Show details"} tKey={"apilog.table.tooltip.showDetails"} />,
                  action: this.handleDetailAction,
                },
              ]}
              dataMapping={[
                { dbfield: "id", editable: false },
                {
                  dbfield: "level",
                  editable: false,
                  customRender: this.handleCustomLevel,
                },
                { dbfield: "api", editable: false },
                { dbfield: "vestiging.systeemNaam" },
                { dbfield: "call", editable: false },
                { dbfield: "message", editable: false },
                { customData: this.handleCustomDatum },
              ]}
              dbfields={"id,level,api,call,message,created_at,vestiging_id,vestiging.id,vestiging.systeemNaam"}
              fetchUrl={"core/callbacklog"}
              filters={this.props.filters}
              headerIcon={<ViewCarousel />}
              headers={[
                { label: getTranslation("callbacklog.table.id", "#"), sortable: false },
                {
                  label: getTranslation("callbacklog.table.level", "level"),
                  sortable: true,
                  sortKey: "level",
                },
                {
                  label: getTranslation("callbacklog.table.api", "API"),
                  sortable: true,
                  sortKey: "api",
                },
                {
                  label: getTranslation("callbacklog.table.vestiging", "Vestiging"),
                  sortable: true,
                  sortKey: "vestiging.naam",
                },
                {
                  label: getTranslation("callbacklog.table.call", "Functie"),
                  sortable: true,
                  sortKey: "call",
                },
                {
                  label: getTranslation("callbacklog.table.message", "message"),
                  sortable: false,
                },
                {
                  label: getTranslation("callbacklog.table.created_at", "Aangemaakt"),
                  sortable: false,
                },
              ]}
              reduxKey={"callbacklog"}
              showAutoRenew
              showRefresh
              tableTitle={<TranslationWrapper tDefault={"Callbacklog"} tKey={"callbacklog.table.titel"} />}
            />
          </GridItem>
        </GridContainer>

        {/*POPUPS*/}
        <Detail
          callbacklogId={this.state.selectedId}
          open={this.state.detailModel}
          toggle={() => this.toggleModal("detailModel")}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let filters = getVestigingFilterState(state, true);
  if (state.filtersV2["callbacklog:api"]) {
    filters["callbacklog:api"] = state.filtersV2["callbacklog:api"];
  }
  if (state.filtersV2["callbacklog:level"]) {
    filters["callbacklog:level"] = state.filtersV2["callbacklog:level"];
  }
  return {
    filters,
  };
};

export default connect(mapStateToProps)(withStyles(Index, tafelStyle));
